import React, { useRef } from 'react';

import { ASK_AI } from '@lumapps/ask-ai/keys';
import { mdiArrowRight, mdiSparkles } from '@lumapps/lumx/icons';
import { Button, Emphasis } from '@lumapps/lumx/react';
import { useTranslate } from '@lumapps/translations';
import { useFocus } from '@lumapps/utils/hooks/useFocus';

interface ResumeConversationButtonProps {
    onClick: () => void;
    followUpQuestionsLength: number;
    className?: string;
}

/**
 * Button displayed to resume an ask ai conversation.
 * Displays the number of currently asked questions.
 */
export const ResumeConversationButton: React.FC<ResumeConversationButtonProps> = ({
    onClick,
    followUpQuestionsLength,
    className,
}) => {
    const { translateAndReplace, pluralize } = useTranslate();

    const ref = useRef<HTMLButtonElement>(null);
    /**
     * As the button appears once the conversation is closed,
     * we need to set focus to it in order to not loose focus.
     */
    useFocus(ref);

    return (
        <Button
            onClick={onClick}
            emphasis={Emphasis.low}
            leftIcon={mdiSparkles}
            rightIcon={mdiArrowRight}
            className={className}
            ref={ref}
        >
            {translateAndReplace(pluralize(ASK_AI.COUNT_FOLLOW_UP_QUESTIONS, followUpQuestionsLength), {
                count: followUpQuestionsLength,
            })}
        </Button>
    );
};
